module.exports = __webpack_public_path__ + "img/blocks-image-73-1-img8.5f136878.jpg";